import React, { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PATHS } from '../../router/paths';

const MESSAGES = {
    unauthorized: {
        heading: 'Access denied',
        body: 'Your account no longer has access to this application. Contact your organization administrator if you believe this is a mistake.',
    },
    default: {
        heading: 'You have been signed out',
        body: 'Your session has ended. Sign in again to continue.',
    },
};

const SignedOut = () => {
    const [searchParams] = useSearchParams();
    const message = useMemo(
        () => MESSAGES[searchParams.get('reason')] ?? MESSAGES.default,
        [searchParams],
    );

    const onSignIn = useCallback((event) => {
        event.preventDefault();
        window.location.assign(PATHS.ROOT);
    }, []);

    return (
        <div className="logoutContainer">
            <div className="exzeoLogo">
                <img src="/images/exzeo-logo.png" alt="Exzeo" />
            </div>
            <div className="logoutScreen" role="status">
                <div className="associateHead rowSpaceBetween alignMiddle">
                    <h3>{message.heading}</h3>
                </div>
                <p style={{ margin: '1rem 0' }}>{message.body}</p>
                <div className="accountAcces textCenter">
                    <a href={PATHS.ROOT} onClick={onSignIn}>Sign in again</a>
                </div>
            </div>
            <div className="footer react-auth-footer">
                <small>
                    Copyright &copy; {new Date().getFullYear()} Exzeo USA, Inc. All rights reserved.
                </small>
            </div>
        </div>
    );
};

export default SignedOut;
